import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { BackListButton, Loading, ToastContext } from '@reveni-io/reveni-ui'

import AppContext from '@/common/context/app.context'
import ParcelInfoHeader from '@/parcels/components/ParcelInfoHeader/ParcelInfoHeader'
import { isInternationalAddresses } from '@/parcels/helpers/helpers'
import useParcel from '@/parcels/hooks/useParcel/useParcel'
import routes from '@/Router/routes.constants'

import useParcelSplit from './hooks/useParcelSplit'
import ProductsCard from './ProductsCard/ProductsCard'
import SummaryCard from './SummaryCard/SummaryCard'
import * as Styles from './styles'

const ParcelSplitPage = () => {
  const { id } = useParams()
  const { info } = useContext(AppContext)
  const { setToastInfo } = useContext(ToastContext)

  const { t } = useTranslation()
  const { loading, parcel } = useParcel({ id, storeId: info?.selectedStore?.id })

  const {
    locations,
    carrierServices,
    fetchingCarriers,
    selectedItemsIds,
    onToggleItem,
    carrierServiceForNewShipment,
    setCarrierServiceForNewShipment,
    locationForNewShipment,
    setLocationForNewShipment,
    splittingParcel,
    isSplitParcelEnable,
    onSplitParcel,
  } = useParcelSplit({ parcel, storeId: info?.selectedStore?.id, setToastInfo })

  return (
    <Styles.Container>
      <Loading show={loading || fetchingCarriers}>
        <div>
          <BackListButton to={routes.parcelDetailPage.replace(':id', id)}>{t('Volver al detalle')}</BackListButton>
        </div>
        <ParcelInfoHeader
          orderName={`${t('Partir envío')} ${parcel?.order?.name}`}
          parcelType={parcel?.type}
          isExchange={parcel?.order?.is_exchange}
          isInternational={isInternationalAddresses(parcel?.origin, parcel?.destination)}
          withCustoms={parcel?.related?.with_customs}
          senderAddress={parcel?.origin}
          recipientAddress={parcel?.destination}
          showMoreActions={false}
        />
        <Styles.MainContainer>
          <ProductsCard
            lineItems={parcel?.related?.line_items || []}
            selectedItemsIds={selectedItemsIds}
            onToggleItem={onToggleItem}
          />
          <SummaryCard
            lineItems={parcel?.related?.line_items || []}
            selectedItemsIds={selectedItemsIds}
            parcelId={id}
            carrierServices={carrierServices}
            locations={locations}
            carrierServiceForNewShipment={carrierServiceForNewShipment}
            setCarrierServiceForNewShipment={setCarrierServiceForNewShipment}
            locationForNewShipment={locationForNewShipment}
            setLocationForNewShipment={setLocationForNewShipment}
            splittingParcel={splittingParcel}
            isSplitParcelEnable={isSplitParcelEnable}
            onSplitParcel={onSplitParcel}
          />
        </Styles.MainContainer>
      </Loading>
    </Styles.Container>
  )
}

export default ParcelSplitPage
